<template>
  <div ref="studentsPage">
    <div v-if="$route.name != 'StudentDocumentsMonitor'" class="w-full">
      <vx-card id="studentsCard" ref="students" title="Students">

        <vs-table :sst="true" @search="handleSearch" @change-page="handleChangePage" stripe ref="studentsTable" class="vs-con-loading__container" single @selected="handleSelectedStudent" pagination :max-items="pageSize" search :data="students" v-scroll-to="'#studentDocsCard'"> <!-- @sort="handleSort" -->
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
            <div>
              <vs-checkbox v-model="showInactive" color="warning">Show Inactive Students</vs-checkbox>
            </div>
          </div>
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Mobile Number</vs-th>
            <vs-th>ID Number</vs-th>
            <vs-th>Email</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="student" :state="student.isActive == false ? 'warning':null" :key="indextr" v-for="(student, indextr) in data" >

              <vs-td :data="data[indextr].userFirstName">
                {{ student.userFirstName + " " + student.userLastName }}
              </vs-td>

              <vs-td :data="data[indextr].mobile">
                {{ student.mobile }}
              </vs-td>

              <vs-td :data="data[indextr].idNumber">
                {{ student.idNumber }}
              </vs-td>

              <vs-td :data="data[indextr].email">
                {{ student.email }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>

    <div v-else class="w-full">
      
      <vx-card id="studentsCard" ref="students" >        
        <div class="vx-row w-full">
          <div class="vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
            <label>Company</label>
            <v-select ref="CompanyDropDown" class="w-full mb-2" placeholder="Search / Select Module" :options="companyList" v-model="selectedCompany"></v-select>
          </div>
        </div>
        <vs-table v-show="selectedCompany" :sst="true" @search="handleSearch" @change-page="handleChangePage" stripe ref="studentsTable" single @selected="handleSelectedStudent" pagination :max-items="pageSize" search :data="students" v-scroll-to="'#studentDocsCard'"> <!-- @sort="handleSort" -->
          
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Mobile Number</vs-th>
            <vs-th>ID Number</vs-th>
            <vs-th>Email</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="student" :state="student.isActive == false ? 'warning':null" :key="indextr" v-for="(student, indextr) in data" >

              <vs-td :data="data[indextr].userFirstName">
                {{ student.userFirstName + " " + student.userLastName }}
              </vs-td>

              <vs-td :data="data[indextr].mobile">
                {{ student.mobile }}
              </vs-td>

              <vs-td :data="data[indextr].idNumber">
                {{ student.idNumber }}
              </vs-td>

              <vs-td :data="data[indextr].email">
                {{ student.email }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <br /><br />
    <div>
      <vx-card id="studentDocsCard" class="vs-con-loading__container" v-show="!isInfoHidden" :title="`${ $route.name != 'StudentDocumentsMonitor' ? `` : `Monitor `  }Documents`">
        <div slot="no-body" class="tabs-container px-3 pt-2">
          <student-document :monitorMode="$route.name == 'StudentDocumentsMonitor'" @reload="loadStudentData" @cancelAdd="cancelAdd" :studentId="studentId" class="mt-4" />
        </div>
      </vx-card>
    </div>
  </div>

</template>

<script>
  import vSelect from 'vue-select'
  import StudentDocument from './StudentDocuments.vue'
  export default {
    components: {
      'v-select': vSelect,
      StudentDocument
    },
    data() {
      return {
        showModulePart: false,
        pageSize: 10,
        transactionsPopupActive: false,
        selectedStudent: {},
        loadingColor:'#fff',
        selected: [],
        studentId: 0,
        isInfoHidden: true,
        isStudentListHidden: false,
        students: [],
        sites: [],
        showInactive: false,
        existingStudent: [],
        mode: "",
        currentSite: "",
        currentStudent: {},
        isLoading: false,
        criteria: {
          pageSize: 0,
          pageNumber: 0,
          sortKey: "",
          sortOrder: "",
          searchPhrase: "",
          showInactive: false
        },
        companyList:[],
        selectedCompany:null
      }
    },
    watch: {
      showInactive: function(val) {
        this.criteria.showInactive = val;
        this.loadStudentData();
      },
      selectedCompany: function(){
        this.loadStudentData();
      }
    },
    methods: {
      initValues() {
        this.isLoading = false;
        this.errors.clear();
        this.$validator.errors.clear();
      },
      cancelAdd() {
        this.isInfoHidden = true;
       
      },
      selectElementContents(elId) {
        var el = document.getElementById(elId);
        var body = document.body, range, sel;
        if (document.createRange && window.getSelection) {
          range = document.createRange();
          sel = window.getSelection();
          sel.removeAllRanges();
          try {
            range.selectNodeContents(el);
            sel.addRange(range);
          } catch (e) {
            range.selectNode(el);
            sel.addRange(range);
          }
          document.execCommand("copy");
          this.$vs.notify({
            color: "success",
            text: "Copied!",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-clipboard"
          });
        } else if (body.createTextRange) {
          range = body.createTextRange();
          range.moveToElementText(el);
          range.select();
          range.execCommand("Copy");
          this.$vs.notify({
            color: "success",
            text: "Copied!",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-clipboard"
          });
        }
        sel.removeAllRanges();
      },
   
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          return v[j]
        }))
      },
      loadStudentData() {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function (response) {
          self.students = [];

          if(self.criteria.pageNumber > 1)
            self.students[((self.criteria.pageNumber - 1) * self.pageSize) - 1] = {};
          
          self.students = self.students.concat(response.data.records);
          
          if(response.data.count > (self.criteria.pageNumber * self.pageSize))
            self.students[response.data.count - 1] = {};

          if (self.$route.query.studentDocumentId) {
            self.getStudentIdFromStudentDocumentId();
          }
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.studentsTable.$el);
        };
        if(!this.selectedCompany){
          self.$ajaxPost(self, "Student/GetStudentsSst", self.criteria, onSuccess, onFinally);
        }
        else{
          self.$ajaxPost(self, `Student/GetStudentsSst/${this.selectedCompany.value}`, self.criteria, onSuccess, onFinally);
        }
      },
      getCurrentStudent() {
        var self = this;
        var onSuccess = function (response) {
          self.currentStudent = response.data;
        };
        self.$ajaxGet(self, "user/GetCurrentUserInfo", onSuccess);
      },
      handleSelectedStudent(student) {
        var self = this;
        self.studentId = student.id;
        self.isInfoHidden = false;
      },
    
      successUpload(data) {
        this.formData.uploadedFileName = data[0].url;
        this.$vs.loading.close(this.$refs.fileUpload.$el);
        this.isLoading = false;
      },
      showUpload() {
        this.formData.uploadedFileName = null;
      },
     showLoadingOnTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.studentsTable.$el,
          scale: 1
        });
      },
      showLoadingOnUploader(){
        var self = this;
        self.isLoading = true;
        self.$vs.loading({
          type: "material",
          container: self.$refs.fileUpload.$el,
          scale: 0.45
        });
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      scrollToNavbar(elementId) {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
      },
     
      handleSearch(searchPhrase) {
        var self = this;

        if(searchPhrase.length >= 3){
          self.criteria.searchPhrase = searchPhrase;
          self.criteria.showInactive = self.showInactive;

          self.loadStudentData();
        }
        else if (searchPhrase == ""){
          self.criteria.searchPhrase = searchPhrase;
          self.loadStudentData();
        }
      },
      handleChangePage(pageNumber) {
        var self = this;

        if(pageNumber > 0) {
          self.criteria.pageNumber = pageNumber;
          self.criteria.showInactive = self.showInactive;

          self.loadStudentData();
        }
      },
      handleSort(sortKey, sortOrder) {
        var self = this;

        self.criteria.sortKey = sortKey;
        self.criteria.sortOrder = sortOrder;
        self.criteria.showInactive = self.showInactive;

        self.loadStudentData();
      },
      getStudentIdFromStudentDocumentId() {
        var self = this;
        var onSuccess = function (response) {
          var studentObj = response.data;
          self.handleSelectedStudent(studentObj);
          setTimeout(() => {
            self.scrollToElement(`studentDocsCard`);
          }, 100);
        };
        self.$ajaxGet(self, `Assessor/GetStudentInfoFromStudentDocumentId/${self.$route.query.studentDocumentId}`, onSuccess);
      },
      scrollToElement(elementId) {
        var scrollOptions = {
          easing: "ease-in-out",
          offset: -100,
          force: true,
          cancelable: true,
          x: false,
          y: true
        };
        var cancelScroll = this.$scrollTo(document.getElementById(elementId), 500, scrollOptions);
      },
      getCompanies(){
        var self = this;
        self.showLoadingOnElement("CompanyDropDown",0.45,"corners");
        var onSuccess = response =>{
          self.companyList = response.data.map((item) => {return {label: item.text, value: item.value} });
        }
      
        var onFinally = response =>{
          if(self.$refs.CompanyDropDown){
            self.$vs.loading.close(self.$refs.CompanyDropDown.$el);
          }
        }
      
        self.$ajaxGet(self, `monitor/siteCompany` , onSuccess, onFinally);
      },
    },
    mounted() {
      var self = this;
      self.showLoadingOnTable();

      self.criteria.pageSize = self.pageSize;
      self.criteria.pageNumber = self.$refs.studentsTable.currentPage;

      if(this.$route.name != 'StudentDocumentsMonitor'){
        self.loadStudentData();
      }
      else{
        self.getCompanies();
      }

      if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
        self.currentSiteTypeId = JSON.parse(localStorage.getItem("userSiteInfo"))[0].siteTypeId;
      else
        self.currentSiteTypeId = JSON.parse(localStorage.getItem("userSiteInfo")).siteTypeId;
    },
  }

</script>

<style lang="scss">
  div#transactionsPopup.vs-component.con-vs-popup.vs-popup-primary {
    div.vs-popup {
      header.vs-popup--header {
        i.vs-icon.notranslate.icon-scale.vs-popup--close.vs-popup--close--icon.material-icons.null {
          background: rgb(253, 0, 0) !important;
          color: rgb(255, 255, 255);
        }
      }
    }
  }

  #profileimg {
    border-radius: 50%;
    padding:2px;
    border:1px solid #838383;
    background-color:rgb(255, 255, 255);
    /* max-width: 100px; */
  }

  .v-select {
    overflow: unset;
  }

  #modulesTable {
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        > span {
          padding-inline-end: 30px;
          width: calc(100% - 200px);
        }
      }
  }

  #profilerow {
    align-items: center;
  }

  .text {
    border-radius: 50%;
    color: rgb(41, 41, 41);
    font-size: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
    text-shadow: 2px 2px 5px rgb(255, 255, 255);
  }

  .container:hover .overlay {
    opacity: 1;
    border-radius: 50%;
  }

  .container {
    position: relative;
    width: 50%;
    border-radius: 50%;
  }

  .overlay {
    border-radius: 50%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: .5s ease;
  }
</style>
